import { getToken } from '@ocenkatech/common/models';
import { useAppSelector } from 'app/hooks';

export const useGetToken = () => {
    return useAppSelector(getToken);
};
